// The one place that says where Intranet analytics go. The project key is public by design
// (it ships in every page's JavaScript), so it lives here and not in a server .env file.
export const POSTHOG = {
  projectKey: "phc_uN9RQkpdAcTAQzRHcARYnAAxwJ3VfjLZ8pX9RXSiRaVz",
  apiHost: "https://us.i.posthog.com",
  uiHost: "https://us.posthog.com",
};

// Only the real intranet is counted: never a developer's machine or a dev, test or pre-prod copy.
// Which hosts those are is a rule about the name, so no company address is written in the code.
const SILENT_FIRST_LABELS = new Set(["dev", "pre-prod", "preprod", "staging", "stage", "test", "qa", "proto"]);
export const isTrackedHost = (host) => {
  const name = String(host || "").toLowerCase().split(":")[0];
  if (!name || name === "localhost" || name.endsWith(".local") || /^[0-9.]+$/.test(name)) return false;
  return !SILENT_FIRST_LABELS.has(name.split(".")[0]);
};

// The admin panel is not counted. Its old addresses are listed because they redirect into it.
const ADMIN_PREFIXES = ["/company-admin", "/admin-panel", "/plan-and-plugins"];
export const isAdminPath = (pathname) =>
  ADMIN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
